import { Card } from '@/components/ui/card';
import { formatDate } from '@/utils/date';
import { PartyPopper } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type Props = {
	name: string;
	icon?: React.ReactNode;
	date: string;
	id: number;
};

const ListCard = ({ name, date, id }: Props) => {
	const navigate = useNavigate();
	return (
		<Card
			onClick={() => navigate('/list/' + id)}
			className="flex cursor-pointer items-center gap-4 rounded-md border border-gray-200 px-4 py-3 transition hover:shadow-md dark:border-gray-800 sm:max-w-md"
		>
			<div className="px-1">
				<PartyPopper className="h-6 w-6 text-gray-500 dark:text-gray-400" />
			</div>
			<div className="space-y-1">
				<h4 className="text-sm font-medium">{name}</h4>
				<p className="text-sm text-gray-500 dark:text-gray-400">
					{formatDate(date)}
				</p>
			</div>
		</Card>
	);
};

export default ListCard;
